import { environment } from '../../../environments/environment';

export const BaseUrl = {

    PATIENT: environment.apiURL + 'storegene-patient-v3-api',
    USER: environment.apiURL + 'storegene-user-v3-api',
    TEMPLATE: environment.apiURL +'storegene-genomics-template-v3-api',
    CONTROL: environment.apiURL + 'storegene-genomics-control-v3-api',
    SYSTEM: environment.apiURL + 'storegene-genomics-system-v3-api',
    LOGO: environment.logo,
    APPTITLE: environment.appTitle,
};